// --------------------------------for desktop----------------------------//
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useAlert } from 'react-alert';
import { Alert, Container, Row, Modal, Offcanvas, Button, FormSelect, ProgressBar } from 'react-bootstrap';
import api from '../../seller-apis/api';
import servicesApi from '../../seller-apis/servicesApi';
import './register.css';
// Images related
var imagesName = [];
var s3Urls = [];


function Register1() {

    const alert = useAlert();

    // Input fields

    const [gstNo, setGstNo] = useState("");


   


   

    // Verify gst 

    function verifyGst() {
      // setGstNo(gstNo.toUpperCase())
        if(gstNo === "" || gstNo === undefined){
            alert.info("Please enter your GST no.")
        }
        else{
          console.log(gstNo)
          const regex = new RegExp("^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$");
          if(regex.test(gstNo.toUpperCase())){
            
            let registrationdata = {
                 "gstNo":gstNo.toUpperCase()
             }
             api.auth.registerSeller(registrationdata)
             .then((res)=>{
               console.log(res)
               if(res.data.message === "Vendor registerd"){
                   localStorage.setItem("gst",gstNo.toUpperCase());
                   localStorage.setItem('vendorId',res.data.data)
                 window.location.assign('/register/2')
               }
               else{
                 alert.info(res.data.message)
               }
            
             }).catch((err)=>{
             
                 console.log(err)
             })
         }
         else{
           console.log(gstNo)
          alert.info("Please enter correct GST no.")
         }
        }
       
    }

   

  return (
    <div className='form-register'>


      <div className='text-center p-2'><img src='seller-test.png' className='w-15'></img></div>
                    <div className='text-white bg-theme text-center  fs-16 py-1 '>
                REGISTRATION FORM
            </div>
          
            <div className='container mt-5 pt-5'>
              
                    <p className='text-center mt-3 fs-19 f-700 mb-1 mt-2'>
                        GST Number<span className='text-danger'>*</span>:


                    </p>
                    <div className='text-center theme-col fs-18 f-700 mt-2'>
                        <input type='text' value={gstNo} onChange={(e) => setGstNo(e.target.value)} className='theme-line corner py-1 w-60 px-3 my-3' ></input><br></br>
                        <br></br>
                        <button className='bg-theme text-white b-n px-3 py-1 corner fs-19 w-25  mx-2' onClick={() => verifyGst()}>Verify</button>

                    </div>
                
    </div>
    </div>
  )
}

export default Register1;





